<template>

  <div>

    <b-container>

      <div class="mt-4 mb-4 d-flex align-items-center justify-content-between">
        <div class="burger-spacing">
          <h1 class="page-title">{{$t('ProjectTypes')}}</h1>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
          {{$t('Add')}} {{$t('a')}} {{$t('projectType')}}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b122-table
          ref="B122TableProjectType"
          identifier="B122TableProjectType"
          init-b122-table-url="/projectType/initB122Table"
          get-b122-table-results-url="/projectType/getB122TableResults"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('projectType.emptyTitle').toString()"
          :empty-text="$t('projectType.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn">
        </b122-table>
      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <Item-delete-modal
      itemSingularName="projectType"
      :beginsWithVoyel="false"
      :selectedItem="ui.selectedProjectType"
      :selectedItemSpecialString="ui.selectedProjectType ? ui.selectedProjectType.tostring : null"
      controllerName="projectType"
      itemSingularNameUpp="ProjectType"
      @didDeleteItem="didDeleteProjectType()">
    </Item-delete-modal>

  </div>

</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue"
import i18n from "../../i18n"

export default {

  name: 'ProjectTypeIndex',

  components: {
    ItemDeleteModal,
    B122Table,
  },

  data() {
    return {

      totalCount: 0,
      allowCreate: this.$store.getters.isAdmin,
      allowDelete: this.$store.getters.isAdmin,
      allowEdit: this.$store.getters.isAdmin,

      ui: {
        selectedProjectType: null
      }

    }
  },

  computed: {

    tableFields() {
      return [
        {
          label: this.$i18n.t('projectType.Name'),
          key: 'name',
          sortable: true
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'ProjectTypeCreate'
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'ProjectTypeEdit',
        params: {
          projectTypeId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedProjectType = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteProjectType() {
      this.ui.selectedProjectType = null
      this.$refs.B122TableProjectType.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/projectType/ProjectTypeIndex.vue